/**
 * Vendors
 */
import React, { useState, useEffect } from 'react';
import { bool, func, shape, string, object, number, node } from 'prop-types';
import { Button, Fade } from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
// import { CSSTransition } from 'react-transition-group';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
import copy from 'copy-to-clipboard';

/**
 * Components
 */
import Loader from '../Loader/Loader';

/**
 * API Service
 */
import { statistics } from '../../services/ApiService';

/**
 * PropTypes
 */
const propTypes = {
  setSharingState: func.isRequired,
  isLoading: bool.isRequired,
  showAlert: func.isRequired,
  requestParams: shape({ type: string, params: object }).isRequired,
  theme: number.isRequired,
  children: node,
};

const defaultProps = {
  theme: 1,
};

/**
 * Expo
 */
const StatisticsShare = ({
  isLoading,
  setSharingState,
  showAlert,
  requestParams,
  theme,
  children,
}) => {
  const [shareLink, setShareLink] = useState(null);
  const [copied, setCopyState] = useState(false);

  // id таймера показа уведомления о скопированной ссылке
  let timerId = null;

  const getStats = () => {
    setSharingState(true);
    const { type, params } = requestParams;
    statistics
      .shareStatistics(type, params)
      .then((response) => {
        const hash = response?.items?.[0]?.share;
        const link = makeShareLink(hash);
        // копируем ссылку в буфер
        copy(link);
        // выводим сообщение
        setCopyState(true);
        // прячем сообщение через 3с
        timerId = setTimeout(() => {
          setCopyState(false);
        }, 3000);
        // выводим дисклеймер
        setShareLink(link);
      })
      .catch((err) => {
        showAlert({
          message: err.toString(),
          alertType: 'danger',
          closeInSeconds: 5,
        });
      })
      .finally(() => {
        setSharingState(false);
      });
  };

  /**
   * Копируем ссылку на картинку и отображаем это в UI
   */
  // const handleCopy = () => {
  //   setCopyState(true);
  //   timerId = setTimeout(() => {
  //     setCopyState(false);
  //     setShareLink(null);
  //   }, 1200);
  // };

  const makeShareLink = (hash) => {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname.replace('my', 'share')}/${hash}`;
    // return 'https://s1.stage.offerrum.com/' + hash;
  };

  useEffect(() => {
    // очищем таймаут на unmount'е
    return () => window.clearTimeout(timerId);
  }, []);

  return (
    <div className="statistics-share">
      {/* {shareLink ? ( */}
      {/* <Fragment> */}
      {/* <CSSTransition
              // поле видно, когда существует ссылка
              // скрывается после копирования
              in={!!shareLink && !copied}
              timeout={0}
              classNames="share-input-transition"
              appear
            >
              <Input
                type="text"
                bsSize="md"
                readOnly
                className="form-group-input"
                value={shareLink}
              />
            </CSSTransition> */}
      {/* <CopyToClipboard onCopy={handleCopy} text={shareLink}>
              <Button color={copied ? 'success' : 'primary'} size="md" className="form-group-btn">
                {copied ? (
                  <FormattedMessage id="main.copied" defaultMessage="Copied" />
                ) : (
                  <FormattedMessage id="main.copy" defaultMessage="Copy" />
                )}
              </Button>
            </CopyToClipboard> */}
      {/* </Fragment> */}
      <button className="statistics-share-button" onClick={getStats}>
        {children}
      </button>
      <Fade in={copied}>
        <span className="copied-message">
          <FormattedMessage id="statistics.share.message" defaultMessage="Copied to clipboard" />
        </span>
      </Fade>
      {/* <Button
          color="primary"
          size="md"
          className="form-group-btn btn-with-loader"
          onClick={getStats}
          disabled={isLoading}
        >
          <FormattedMessage id="statistics.share.button" defaultMessage="Share" />
          {isLoading && <Loader isInButton />
        </Button> */}
      {/* {shareLink && theme !== 1 && (
        <div className="statistics-share-disclaimer">
          <FormattedHTMLMessage
            id="statistics.share.disclaimer.theme"
            defaultMessage="Your statistics will appear in the Light theme of the interface."
            tagName="span"
          />
        </div>
      )} */}
    </div>
  );
};

StatisticsShare.propTypes = propTypes;
StatisticsShare.defaultProps = defaultProps;

export default StatisticsShare;
